

import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import { toast } from "react-toastify";
import { MdMemory } from "react-icons/md";
import { LuLogIn } from "react-icons/lu";
import "./OperatorLogin.css";

export default function OperatorLogin() {
  const [pin, setPin] = useState("");
  const navigate = useNavigate();
  // useEffect(() => {
  //   const storedUser = localStorage.getItem("user");

  //   if (storedUser) {
  //     const user = JSON.parse(storedUser);

  //     if (user?.access_token) {
  //       navigate("/dashboard");
  //     }
  //   }
  // }, [navigate]);

useEffect(() => {
  const storedUser = localStorage.getItem("user");

  if (storedUser) {
    const user = JSON.parse(storedUser);

    if (user?.access_token) {

      const role = user?.user?.role;

      switch (role) {

        case "operator":
          navigate("/dashboard");
          break;

        case "senior_manager":
          navigate("/senior-management");
          break;

        case "inspection":
          navigate("/inspection-dashboard");
          break;

        case "manager":
          navigate("/management-dashboard");
          break;

        case "supervisor":
          navigate("/supervisor-dashboard");
          break;

        case "admin":
          navigate("/admin");
          break;

        default:
          navigate("/login");
      }
    }
  }
}, [navigate]);

  const addDigit = (num) => {
    if (pin.length < 4) setPin(pin + num);
  };
  const removeDigit = () => setPin(pin.slice(0, -1));
  const clearPin = () => setPin("");
  const handleLogin = async () => {
    if (pin.length !== 4) return;
    try {
      const res = await axios.post(`${config.API}/operator/login`, {
        username: pin,
        password: "12345678",
      });
      localStorage.setItem("user", JSON.stringify(res.data));
      toast.success("Login successful");
      navigate("/dashboard");
    } catch (err) {
      const message = err.response?.data?.error || "Login failed";
      toast.error(message);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="left-panel font_family">
          <div className="left-content">
            <div className="d-flex align-items-center gap-3">
              <div
                className="d-flex align-items-center justify-content-center fs-2"
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "12px",
                  background:
                    "linear-gradient(145deg, rgba(248,249,251,0.65), rgba(238,243,242,0.65))",
                  color: "#fff",
                }}
              >
                <MdMemory />
              </div>

              <div className="brand mt-3">PRAG</div>
            </div>
            <h1>
              Prag Production <br /> System
            </h1>
            <p className="fw-bold">
              Industrial monitoring and control interface.
            </p>
            <div className="dev-text">
              DESIGNED AND DEVELOPED BY KENSAA
            </div>
          </div>
        </div>
        <div className="right-panel font_family text-center">
          <h2 className="fw-bold mt-5">Operator Login</h2>
          <p className="subtitle fw-bold">
            Please enter your 4-digit PIN to continue.
          </p>
          <div className="dots">
            {[0, 1, 2, 3].map((i) => (
              <span key={i} className={pin.length > i ? "active" : ""}></span>
            ))}
          </div>
          <div className="keypad">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
              <button key={n} onClick={() => addDigit(n)} className="fw-bold">
                {n}
              </button>
            ))}
            <button onClick={clearPin} className="fw-bold">✕</button>
            <button onClick={() => addDigit(0)} className="fw-bold">0</button>
            <button onClick={removeDigit} className="fw-bold">⌫</button>
          </div>
          <button
            className="login-btn"
            disabled={pin.length !== 4}
            onClick={handleLogin}
          >
            <LuLogIn /> Login
          </button>
          <div className="switch">
            🔑 <Link to="/login">Switch to Other Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}


